export default function searchButton(){
    const searchs = document.querySelectorAll(".header__search");

    searchs.forEach(search => {
        const open = search.querySelector(".open");
        const close = search.querySelector(".close");
        const block = search.querySelector(".menu__block");

        open.addEventListener("click", () => {
            block.style.display = "flex";

            setTimeout(() => {
                block.style.opacity = "1";
            }, 100);

            open.style.display = "none";
            close.style.display = "block";
            close.style.opacity = "1";
        });

        close.addEventListener("click", () => {
            block.style.opacity = "0";

            setTimeout(() => {
                block.style.display = "none";
            }, 400);

            close.style.display = "none";
            open.style.display = "block";
        });
    });
}
